import { EventActorRef } from "@/types/entity"
import { DetailedEventActor } from "@/types/event-actor"
import { EventParams, EventSummary } from "@/types/place"

import { PagingMeta } from "@/lib/paging"
import { baseApi } from "./base-api"

export interface GetDetailedEventActorArgs {
  eventActorRef: EventActorRef
  eventParams?: EventParams
}

export interface GetEventsForEventActorArgs {
  eventActorRef: EventActorRef
  eventParams?: EventParams
}

export interface EventsResponse {
  data: EventSummary[]
  meta: PagingMeta
}

export const eventActorApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDetailedEventActor: builder.query<
      DetailedEventActor,
      GetDetailedEventActorArgs
    >({
      query: ({ eventActorRef, eventParams }) => {
        const params = new URLSearchParams()
        if (eventParams?.page !== undefined) {
          params.append("page", eventParams.page.toString())
        }
        if (eventParams?.per_page !== undefined) {
          params.append("per_page", eventParams.per_page.toString())
        }
        if (eventParams?.at !== undefined) {
          params.append("at", eventParams.at.toString())
        }
        if (eventParams?.from !== undefined) {
          params.append("from", eventParams.from.toString())
        }
        if (eventParams?.to !== undefined) {
          params.append("to", eventParams.to.toString())
        }
        const queryString = params.toString()
        const url = queryString
          ? `/api/event_actors/${eventActorRef}/detailed?${queryString}`
          : `/api/event_actors/${eventActorRef}/detailed`

        return {
          url,
          impressionIdHeader: "Impression-Id",
        }
      },
      providesTags: (result, _error, { eventActorRef }) =>
        result ? [{ type: "DetailedEventActor", id: eventActorRef }] : [],
    }),
    getEventsForEventActor: builder.query<
      EventsResponse,
      GetEventsForEventActorArgs
    >({
      query: ({ eventActorRef, eventParams }) => {
        const params = new URLSearchParams()
        if (eventParams?.page !== undefined) {
          params.append("page", eventParams.page.toString())
        }
        if (eventParams?.per_page !== undefined) {
          params.append("per_page", eventParams.per_page.toString())
        }
        if (eventParams?.at !== undefined) {
          params.append("at", eventParams.at.toString())
        }
        if (eventParams?.from !== undefined) {
          params.append("from", eventParams.from.toString())
        }
        if (eventParams?.to !== undefined) {
          params.append("to", eventParams.to.toString())
        }
        const queryString = params.toString()
        const url = queryString
          ? `/api/event_actors/${eventActorRef}/events?${queryString}`
          : `/api/event_actors/${eventActorRef}/events`

        return {
          url,
          impressionIdHeader: "Impression-Id",
        }
      },
      transformResponse: (response: { events: EventsResponse }) =>
        response.events,
      providesTags: (result, _error, { eventActorRef }) =>
        result ? [{ type: "EventActorEvents", id: eventActorRef }] : [],
    }),
  }),
})

export const {
  useGetDetailedEventActorQuery,
  useLazyGetDetailedEventActorQuery,
  useGetEventsForEventActorQuery,
  useLazyGetEventsForEventActorQuery,
} = eventActorApi
